import { GoodwillModel } from './goodwill.model';
import { RevenueModel } from './revenue.model';
import { AssortmentRxModel, AssortmentNonRxModel } from './assortment.model';
import { FeesGeneralModel, FeeReturnsModel } from './fees.model';

export interface EvaluationSum {
  goodwill: number;
  fees: number;
  revenue: number;
  assortment: number;
}

export interface EvaluationData {
  goodwill?: GoodwillModel;
  revenue?: RevenueModel;
  assortment_rx?: AssortmentRxModel;
  assortment_non_rx?: AssortmentNonRxModel;
  fees_general?: FeesGeneralModel;
  fees_returns?: FeeReturnsModel;
  month?: number;
  year?: number;
}
